// TEN PLIK JEST GENEROWANY AUTOMATYCZNIE PRZEZ HUSKY.
// Źródło: permissions-config.json
// NIE EDYTUJ TEGO PLIKU RĘCZNIE.

export const PLANS = {
    "FREE": "Free",
    "PRO": "Pro",
    "ENTERPRISE": "Enterprise"
} as const;

export type UserPlan = typeof PLANS[keyof typeof PLANS];

export const FEATURES = {
    "VIEW_PREMIUM_SECTIONS": "view_premium_sections",
    "RECALCULATE_ESTIMATE": "recalculate_estimate",
    "DOWNLOAD_PDF": "download_pdf",
    "AI_CHAT_ACCESS": "ai_chat_access",
    "AI_EXPLAIN_CHOICE": "ai_explain_choice",
    "AI_GENERATE_JD": "ai_generate_jd",
    "AI_RUN_BENCHMARK": "ai_run_benchmark"
} as const;

export const LIMITS = {
    "PROJECT_LIMIT": "project_limit",
    "AI_QUERY_LIMIT": "ai_query_limit"
} as const;

/** @deprecated Prefer PREMIUM_SURFACES.legacy — kept for REC_* adapters. */
export const PREMIUM_FIELDS = [
    "sections.scalability",
    "sections.risk_analysis",
    "sections.security",
    "pricing_guide",
    "risks",
    "rates",
    "decision",
    "consequences",
    "cost",
    "time",
    "teamSize"
];

/** Shared premium surfaces: legacy (REC_*) + agentic artifacts. */
export const PREMIUM_SURFACES = {
    "legacy": [
        "sections.scalability",
        "sections.risk_analysis",
        "sections.security",
        "pricing_guide",
        "risks",
        "rates",
        "decision",
        "consequences",
        "cost",
        "time",
        "teamSize"
    ],
    "agentic": [
        "risks",
        "estimate",
        "team",
        "plan",
        "techMapping",
        "finops",
        "rfpGapAnalysis",
        "architectureReview",
        "teamHr",
        "aiCostSim",
        "sprintZero",
        "stakeholderLenses",
        "hiringTimeline",
        "architectureHealth",
        "workshop",
        "leanAlternative",
        "architectureDesk",
        "implementationKit"
    ]
} as const;

export type FeatureKey = typeof FEATURES[keyof typeof FEATURES];
export type LimitKey = typeof LIMITS[keyof typeof LIMITS];

interface PlanConfig {
    features: Record<FeatureKey, boolean>;
    limits: Record<LimitKey, number>;
}

export const PLAN_CONFIG: Record<UserPlan, PlanConfig> = {
    [PLANS.FREE]: {
        features: {
            [FEATURES.VIEW_PREMIUM_SECTIONS]: false,
            [FEATURES.RECALCULATE_ESTIMATE]: false,
            [FEATURES.DOWNLOAD_PDF]: true,
            [FEATURES.AI_CHAT_ACCESS]: false,
            [FEATURES.AI_EXPLAIN_CHOICE]: false,
            [FEATURES.AI_GENERATE_JD]: false,
            [FEATURES.AI_RUN_BENCHMARK]: false
        },
        limits: {
            [LIMITS.PROJECT_LIMIT]: 1,
            [LIMITS.AI_QUERY_LIMIT]: 0
        }
    },
    [PLANS.PRO]: {
        features: {
            [FEATURES.VIEW_PREMIUM_SECTIONS]: true,
            [FEATURES.RECALCULATE_ESTIMATE]: true,
            [FEATURES.DOWNLOAD_PDF]: true,
            [FEATURES.AI_CHAT_ACCESS]: true,
            [FEATURES.AI_EXPLAIN_CHOICE]: true,
            [FEATURES.AI_GENERATE_JD]: true,
            [FEATURES.AI_RUN_BENCHMARK]: true
        },
        limits: {
            [LIMITS.PROJECT_LIMIT]: 20,
            [LIMITS.AI_QUERY_LIMIT]: 50
        }
    },
    [PLANS.ENTERPRISE]: {
        features: {
            [FEATURES.VIEW_PREMIUM_SECTIONS]: true,
            [FEATURES.RECALCULATE_ESTIMATE]: true,
            [FEATURES.DOWNLOAD_PDF]: true,
            [FEATURES.AI_CHAT_ACCESS]: true,
            [FEATURES.AI_EXPLAIN_CHOICE]: true,
            [FEATURES.AI_GENERATE_JD]: true,
            [FEATURES.AI_RUN_BENCHMARK]: true
        },
        limits: {
            [LIMITS.PROJECT_LIMIT]: 1000,
            [LIMITS.AI_QUERY_LIMIT]: 1000
        }
    }
};
